import { formatPercentage } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import { LoanDetailsCardProps } from '../../summary/summaryStep';
import { LoanDetailsCard } from './loanDetailsCard';
import { useLoanStore } from '@roc/feature-loans';

export const StabilizedBridgeLoanDetailsCard = observer(
  ({ store, isManualQuote }: LoanDetailsCardProps) => {
    store.loanEconomicsStore.isManualQuote = isManualQuote
    const leverage = store.loanEconomicsStore.getLoanEconomics();
    const ltcPurchasePricePercentage = formatPercentage(leverage.loanToCost);
    const calculatedFields = store.loanEconomicsStore.calculatedFields;

    return (
      <LoanDetailsCard
        store={store}
        keyRatios={`${ltcPurchasePricePercentage}`}
        keyRatiosTooltip={'LTC Purchase Price'}
      />
    );
  }
);
